export default function filter() {
    var wrapper = $('.filterable-wrapper');
    var heading = wrapper.find('h1');
    var description = wrapper.find('.main .description');
    var form = wrapper.find('.sidebar .filter');
    var brands = form.find('input[name="brand"]');

    form.find('a').on('click', function(e) {
        e.preventDefault();

        $(this).parent('label').trigger('click');
    });

    form.find('[name]').on('change keyup init', function(e) {
        if (e.type != 'init') {
            wrapper.addClass('filtered');
            form.addClass('filtered');
            description.slideUp();
        }

        var current_filters = {};

        $.each(form.serializeArray(), function(i, filter) {
            if (filter.value) {
                if (!current_filters[filter.name]) {
                    current_filters[filter.name] = [];
                }

                current_filters[filter.name].push(filter.value);
            }
        });

        wrapper.trigger('filter', [current_filters]);
    });

    $(window).on('load', function() {
        form.find('[name]').eq(0).trigger('init');
    });

    form.on('submit', function(e) {
        e.preventDefault();
    });

    brands.on('change', function() {
        if (!brands.filter(':checked').length) {
            this.checked = true;

            $(this).trigger('change');
        }
    });

    $.each(['product-category', 'product-type', 'dealer-type', 'download-type', 'category'], function(i, filter) {
        var all = form.find('input.' + filter + '-all');

        var checkboxes = form.find('input[name="' + filter + '"]');

        checkboxes.on('change all-init', function() {
            all.prop('checked', !checkboxes.filter(':checked').length);
        }).trigger('all-init');

        all.on('change', function() {
            this.checked = true;
            checkboxes.prop('checked', false);

            checkboxes.eq(0).trigger('change');

            $(window).trigger('product-height-refresh');
        });
    });
};
